import { useState as c, useEffect as f } from "react";
import { registerStoryblokBridge as k } from "./storyblok-js.mjs";
import { BlockTypes as T, MarkTypes as h, RichTextResolver as B, RichTextSchema as C, TextTypes as E, apiPlugin as w, loadStoryblokBridge as A, renderRichText as I, richTextResolver as F, storyblokEditable as L } from "./storyblok-js.mjs";
import { useStoryblokApi as u } from "./index2.mjs";
import { getComponent as _, getCustomFallbackComponent as J, getEnableFallbackComponent as K, setComponents as M, storyblokInit as N } from "./index2.mjs";
import { useStoryblokRichText as m } from "./richtext.mjs";
import { useStoryblokState as $ } from "./client.mjs";
import { default as q } from "./storyblok-rich-text.mjs";
import { convertAttributesInElement as D } from "./utils.mjs";
import { default as H } from "./storyblok-component.mjs";
const x = (s, o = {}, e = {}) => {
  const [n, l] = c({}), i = typeof window < "u" && typeof window.storyblokRegisterEvent < "u", t = u();
  return f(() => {
    if (!t) {
      console.error(
        "You can't use useStoryblok if you're not loading apiPlugin."
      );
      return;
    }
    async function y() {
      const { data: r } = await t.get(
        `cdn/stories/${s}`,
        o
      );
      l(r.story), i && r.story.id && k(
        r.story.id,
        (a) => l(a),
        e
      );
    }
    y();
  }, [s, JSON.stringify(o), t]), t ? (e.resolveRelations = e.resolveRelations ?? o.resolve_relations, e.resolveLinks = e.resolveLinks ?? o.resolve_links, n) : null;
}, g = m;
export {
  T as BlockTypes,
  h as MarkTypes,
  B as RichTextResolver,
  C as RichTextSchema,
  H as StoryblokComponent,
  q as StoryblokRichText,
  E as TextTypes,
  w as apiPlugin,
  D as convertAttributesInElement,
  _ as getComponent,
  J as getCustomFallbackComponent,
  K as getEnableFallbackComponent,
  u as getStoryblokApi,
  A as loadStoryblokBridge,
  k as registerStoryblokBridge,
  I as renderRichText,
  F as richTextResolver,
  M as setComponents,
  L as storyblokEditable,
  N as storyblokInit,
  x as useStoryblok,
  u as useStoryblokApi,
  k as useStoryblokBridge,
  m as useStoryblokRichText,
  g as useStoryblokRichTextResolver,
  $ as useStoryblokState
};
